(() => {
  const desktop = window.matchMedia('(min-width: 750px)');

  function syncRailHeight(gallery) {
    if (!desktop.matches) {
      gallery.style.removeProperty('--meres-gallery-rail-height');
      return;
    }
    const controls = [...gallery.querySelectorAll('slideshow-controls')].find((control) => {
      return control.querySelectorAll('.slideshow-controls__thumbnail').length && getComputedStyle(control).display !== 'none';
    });
    const thumbnails = controls ? [...controls.querySelectorAll('.slideshow-controls__thumbnail')] : [];
    if (!thumbnails.length) return;

    const first = thumbnails[0].getBoundingClientRect();
    const last = thumbnails.at(-1).getBoundingClientRect();
    const height = Math.round(last.bottom - first.top);
    if (height > 0) gallery.style.setProperty('--meres-gallery-rail-height', height + 'px');
  }

  function initialise(gallery) {
    const update = () => requestAnimationFrame(() => syncRailHeight(gallery));
    update();
    new ResizeObserver(update).observe(gallery);
    desktop.addEventListener('change', update);
  }

  function start() {
    document.querySelectorAll('media-gallery[data-presentation="carousel"]').forEach(initialise);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
